import React from 'react';
import { Modal, Alert, Form, Card, Button, Spinner } from 'react-bootstrap';

const EmailModal = ({
  show,
  onHide,
  applicants,
  selectedApplicants,
  emailTemplate,
  setEmailTemplate,
  sendingEmails,
  onSendEmails
}) => (
  <Modal show={show} onHide={onHide} size="lg">
    <Modal.Header closeButton>
      <Modal.Title>Send Reminder Emails</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Alert variant="warning">
        <strong>Note:</strong> This demo simulates email sending. In production, integrate with SendGrid, Mailgun, or AWS SES.
      </Alert>
      <h6>Selected Applicants ({selectedApplicants.length}):</h6>
      <ul style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {applicants
          .filter(a => selectedApplicants.includes(a.ats_number))
          .map(applicant => (
            <li key={applicant.ats_number}>
              {applicant.first_name} {applicant.last_name} ({applicant.email_id})
            </li>
          ))}
      </ul>
      <h6>Edit Email</h6>
      <Form>
        <Form.Group className="mb-3" controlId="emailSubject">
          <Form.Label>Subject</Form.Label>
          <Form.Control
            type="text"
            value={emailTemplate.subject}
            onChange={e => setEmailTemplate(et => ({ ...et, subject: e.target.value }))}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="emailBody">
          <Form.Label>Body</Form.Label>
          <Form.Control
            as="textarea"
            rows={12}
            value={emailTemplate.body}
            onChange={e => setEmailTemplate(et => ({ ...et, body: e.target.value }))}
          />
        </Form.Group>
      </Form>
      <h6>Email Preview:</h6>
      <Card>
        <Card.Body>
          <strong>Subject:</strong> {emailTemplate.subject}
          <hr />
          <strong>Body:</strong>
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            {emailTemplate.body}
          </pre>
        </Card.Body>
      </Card>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Cancel
      </Button>
      <Button
        variant={sendingEmails ? 'secondary' : 'primary'}
        onClick={onSendEmails}
        disabled={sendingEmails}
        style={sendingEmails ? { opacity: 0.7, pointerEvents: 'none' } : {}}
      >
        {sendingEmails && (
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
        )}
        {sendingEmails ? 'Sending...' : 'Send Emails'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default EmailModal;